'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.default = connectField;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _index = require('./index');

function mapStateToProps(state, ownProps) {
  return {
    form: (0, _index.getState)(state, ownProps)
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  var prefix = (0, _index.getPrefix)(ownProps.prefix);

  var _getActions = (0, _index.getActions)(prefix),
      fieldEvent = _getActions.fieldEvent,
      formEvent = _getActions.formEvent,
      formHandler = _getActions.formHandler;

  return {
    fieldEvent: (0, _redux.bindActionCreators)(fieldEvent, dispatch),
    formEvent: (0, _redux.bindActionCreators)(formEvent, dispatch),
    formHandler: (0, _redux.bindActionCreators)(formHandler, dispatch)
  };
}
// This gets state and actions for a specific field. That is all.
// The prefix can be sent via init option or with props on each instance.
function connectField() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Pass in a component and it will get connected for you.
  return function (Component) {
    var mapProps = function mapProps(state, props) {
      return mapStateToProps(state, _extends({}, options, props));
    };
    var mapDispatch = function mapDispatch(dispatch, props) {
      return mapDispatchToProps(dispatch, _extends({}, options, props));
    };
    return (0, _reactRedux.connect)(mapProps, mapDispatch)(Component);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/~/redux-field/lib/connectField.js
// module id = 848
// module chunks = 0